import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { UserEntity } from '../../domain/entities/UserEntity'
import type { UserDto } from '@/backend/market/models/UserDto'
import { RegionMiniModel } from '@/features/region/data/models/RegionMiniModel'

export class UserModel extends UserEntity {
  constructor(dataDto:UserDto ) {
    super()
    mapEntityProperties<UserEntity>(this, dataDto, {
      map: {
        regions: dataDto.regions?.map((region) => new RegionMiniModel(region))
      }
    })
  }
}
